module.exports = __webpack_public_path__ + "img/amx-7.301d6d52.webp";